var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0011 22.5C21.3818 22.5 22.5011 21.3807 22.5011 20C22.5011 18.6193 21.3818 17.5 20.0011 17.5C18.6204 17.5 17.5011 18.6193 17.5011 20C17.5011 21.3807 18.6204 22.5 20.0011 22.5ZM25.6289 15.0018H14.3789C14.0337 15.0018 13.7539 15.2816 13.7539 15.6268V24.3768C13.7539 24.722 14.0337 25.0018 14.3789 25.0018H25.6289C25.9741 25.0018 26.2539 24.722 26.2539 24.3768V15.6268C26.2539 15.2816 25.9741 15.0018 25.6289 15.0018ZM15.0039 22.2789V17.7211C15.7075 17.5106 16.2623 16.9556 16.4725 16.2518H23.5297C23.7404 16.9575 24.2976 17.5136 25.0039 17.7227V22.2773C24.2964 22.4868 23.7385 23.0444 23.5286 23.7518H16.4735C16.2643 23.0464 15.7087 22.4897 15.0039 22.2789Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvIcon4);
export default __webpack_public_path__ + "static/media/adv_icon4.599bcdf3011794981be6abb8d0c551a2.svg";
export { ForwardRef as ReactComponent };